module.exports = __webpack_public_path__ + "img/empty.b35aa4a2.png";